import { IntegrityMonitorRulesAppController } from '../controller/IntegrityMonitorRulesAppController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { DefaultSmartViewId } from '../../integrityMonitorRulesSmartViews/types';

export class IntegrityMonitorRulesAppWebComponent extends BaseWebComponentElement {
  public controller!: IntegrityMonitorRulesAppController;
  private ruleIdsFilterRef: Array<string> = [];

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrityMonitorRulesAppController,
    });
  }

  get currentViewId(): string {
    const value = this.getAttribute('data-current-view-id');
    return value ? value : DefaultSmartViewId.ALL_RULES;
  }

  set currentViewId(value: string | null) {
    const newCurrentViewId = value ? value : DefaultSmartViewId.ALL_RULES;
    this.setAttribute('data-current-view-id', newCurrentViewId);
  }

  get ruleIdsFilter(): Array<string> {
    return this.ruleIdsFilterRef;
  }

  set ruleIdsFilter(value: Array<string>) {
    this.ruleIdsFilterRef = value;
  }
}
